<div id="detail-search">
  <form class="search" [formGroup]="detailSearchForm" (ngSubmit)="onSubmit()">
    <div class="search-body">
      <div class="row">
        <div class="col-3 search-label">
          <label for="contentType">{{ 'CONTENT_TYPE' | translate }}</label>
        </div>
        <div class="col-9 search-input">
          <div class="col-6">
            <select id="contentType" class="form-select input input-sm search-input-select" formControlName="contentType">
              <option *ngFor="let item of contentTypeSelection; let i = index" [value]="item.value" [id]="'contentType' + i">{{
                commonService.getTranslatedMessage(item.viewValue)
              }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label">
          <label for="name">{{ 'FILE_NAME' | translate }}</label>
        </div>
        <div class="col-9 search-input">
          <input id="fileName" class="form-control input input-sm search-input-text" type="text" formControlName="name" />
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label">
          <label for="name">{{ 'CONTENT' | translate }}</label>
        </div>
        <div class="col-9 search-input">
          <input id="content" class="form-control input input-sm search-input-text" type="text" formControlName="content" />
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label">
          <label for="name">{{ 'LOCATION' | translate }}</label>
        </div>
        <div class="col-9 d-flex search-input">
          <div class="form-check d-flex align-items-center">
            <input class="form-check-input input input-sm radio-button-sm" type="radio" formControlName="location" value="ALL" id="all" />
            <label class="form-check-label search-label ml-4" for="all"> {{ 'ALL' | translate }} </label>
          </div>
          <div class="form-check d-flex align-items-center">
            <input class="form-check-input input input-sm radio-button-sm" type="radio" formControlName="location" value="FAVORITED" id="favorited" />
            <label class="form-check-label search-label ml-4" for="favorited"> {{ 'FAVORITES' | translate }} </label>
          </div>
          <div class="form-check d-flex align-items-center">
            <input class="form-check-input input input-sm radio-button-sm" type="radio" formControlName="location" value="TRASHED" id="trashed" />
            <label class="form-check-label search-label ml-4" for="trashed"> {{ 'TRASH' | translate }} </label>
          </div>
          <div class="form-check d-flex align-items-center">
            <input class="form-check-input input input-sm radio-button-sm" type="radio" formControlName="location" value="CHOICE" id="choice" />
            <label class="form-check-label search-label ml-4" for="choice"> {{ 'IN_FOLDER_SELECTED' | translate }} </label>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="f.location.value === 'CHOICE'">
        <div class="col-3"></div>
        <div class="col-9 search-input">
          <div class="input-group">
            <input type="text" class="form-control input input-sm" formControlName="parentName" />
            <span class="input input-sm search-input-file-location" (click)="showModal()"> {{ 'SELECT' | translate }} </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label"> {{ 'OWNER' | translate }}</div>
        <div class="col-9 search-input">
          <div class="row gap-10">
            <div class="col-md-12 col-lg-6 col-xl-4">
              <select (change)="onOwnerOptionsChanged()" id="ownerType" class="form-select input input-sm search-input-select" formControlName="ownerOptions">
                <option *ngFor="let item of ownerOptions; let i = index" [value]="item.value" [id]="'ownerType' + i">{{ commonService.getTranslatedMessage(item.value) }}</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-8 search-input" *ngIf="f.ownerOptions.value === 'SPECIFIC_USERS_OBJECT'">
              <input
                (input)="isSubmitted = false"
                [id]="isSubmitted && f.email.errors?.email ? 'input-error' : null"
                [class.has-error]="isSubmitted && f.email.errors?.email"
                class="form-control input input-sm search-input-text"
                type="text"
                formControlName="email"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label">
          <label for="modifiedDate">{{ 'MODIFY_DATE' | translate }}</label>
        </div>
        <div class="col-9 d-flex flex-row search-input gap-10">
          <div class="d-flex align-items-center flex-1">
            <input (change)="checkDate()" id="beforeDate" type="date" class="form-control input input-sm" [max]="maxDate" formControlName="beforeDate" />
          </div>
          <span class="date-seperator d-flex align-items-center"> - </span>
          <div class="d-flex align-items-center flex-1">
            <input type="date" id="afterDate" class="form-control input input-sm" [min]="f.beforeDate.value" [max]="maxDate" formControlName="afterDate" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-3 search-label">
          <label for="sizeRange">{{ 'SIZE_RANGE' | translate }}</label>
        </div>
        <div class="col-9 d-flex flex-row search-input gap-10">
          <div class="d-flex align-items-center flex-1">
            <div class="combined-input flex-1">
              <input id="minSize" (input)="minSizeChanged($event)" type="text" pattern="[0-9]*" class="form-control input input-sm" formControlName="minSize" />
              <select id="minSizeOptions" class="form-select input input-sm search-input-select" formControlName="minSizeOptions">
                <option *ngFor="let option of options; let i = index" [id]="'minSizeOptions' + i" [value]="option">{{ option }}</option>
              </select>
            </div>
          </div>
          <span class="date-seperator d-flex align-items-center"> - </span>
          <div class="d-flex align-items-center flex-1">
            <div class="combined-input flex-1">
              <input
                id="maxSize"
                (input)="maxSizeChanged($event)"
                [class.has-error]="isSubmitted && detailSearchForm.valid && !isFormValid"
                type="text"
                pattern="[0-9]*"
                class="form-control input input-sm"
                formControlName="maxSize"
              />
              <select id="maxSizeOptions" (change)="maxSizeChanged($event)" class="form-select input input-sm search-input-select" formControlName="maxSizeOptions">
                <option *ngFor="let option of options; let i = index" [id]="'maxSizeOptions' + i" [value]="option">{{ option }}</option>
              </select>
            </div>
          </div>
        </div>
        <small class="error-message" *ngIf="isSubmitted && f.email.errors?.email">{{ 'ENTER_VALID_EMAIL' | translate }} </small>
        <small class="error-message" *ngIf="isSubmitted && detailSearchForm.valid && !isFormValid">{{ 'MAX_SIZE_CANNOT_BE_GREATER' | translate }}</small>
      </div>
    </div>
    <div class="search-footer">
      <div class="d-flex gap-8 py-9">
        <button type="button" id="resetBtn" (click)="resetForm()" class="btn btn-primary btn-outline btn-md">{{ 'RESET' | translate }}</button>
        <button type="submit" id="searchBtn" class="btn btn-primary btn-md">{{ 'SEARCH' | translate }}</button>
      </div>
    </div>
  </form>
</div>
